import React, { useState } from 'react';
import Main from '../../../component/Main.jsx';
import NewDataGrid from '../../../component/common/dataGrid/NewDataGrid.jsx';
import SearchBtn from '../../../component/common/button/SearchBtn.jsx';
import NewCommonSelect from '../../../component/common/selectBox/NewCommonSelect.jsx';

const BdTongeMstay = () => {

    const [searchParams, setSearchParams] = useState({
        searchFromdate: new Date((new Date()).getTime() + 1000 * 60 * 60 * 9).toISOString().split('T')[0],
        searchTodate: new Date((new Date()).getTime() + 1000 * 60 * 60 * 9).toISOString().split('T')[0],
        searchGrdc: '',
        searchLoca: '',
        searchCheck1: '',
        searchCheck2: '',
    });

    const handleInputChange = (e) => {
        const { name, value, type, checked } = e.target;
        const newParams = {
            ...searchParams,
            [name]: type === 'checkbox' ? (checked ? "1" : "") : value
        };
        setSearchParams(newParams);
    };


    const dataHead = [['의료기관명', '종별', '지역', '기관수', '전체환자수', '평균', '귀가', '귀가', '귀가', '귀가', '귀가', '전원', '전원', '전원', '전원', '전원', '전원', '전원', '전원', '입원', '입원', '입원', '입원', '입원', '사망', '사망', '사망', '사망', '사망', '사망', '미상', '기타'],
    ['의료기관명', '종별', '지역', '기관수', '전체환자수', '평균', '증상호전', '말기질환', '자퇴의원', '외래방문', '기타', '병실부족', '중환자실부족', '응급,처치불가', '상급병원', '1,2차의료기관', '장기시설', '환자사정', '기타', '일반병실', '중환자실', '수술실->병실', '수술실->중환자실', '기타', 'DOA', 'DNR', 'CPR후', '가망없는퇴원', 'CPR미실행', '기타', '미상', '기타']];
    const dataColumn = ['TNAME', 'EMCTYPE', 'EMCLOCA', 'EMCCOUNT', 'RECCOUNT', 'TT1', 'TT2', 'TT3', 'TT4', 'TT5', 'TT6', 'TT7', 'TT8', 'TT9', 'TT10', 'TT11', 'TT12', 'TT13', 'TT14', 'TT15', 'TT16', 'TT17', 'TT18', 'TT19', 'TT20', 'TT21', 'TT22', 'TT23', 'TT24', 'TT25', 'TT27', 'TT26'];
    const apiCall = '/ptmiapi/hospAft/bdtongemstaylist.do';
    const apiCntCall = '';
    const searchParamsAdditional = {};
    const excelFileName = "진료결과별 평균재실시간";
    const excelHead = ['의료기관명', '종별', '지역', '기관수', '전체환자수', '평균', '증상호전', '말기질환', '자퇴의원', '외래방문', '기타', '병실부족', '중환자실부족', '응급,처치불가', '상급병원', '1,2차의료기관', '장기시설', '환자사정', '기타', '일반병실', '중환자실', '수술실->병실', '수술실->중환자실', '기타', 'DOA', 'DNR', 'CPR후', '가망없는퇴원', 'CPR미실행', '기타', '미상', '기타'];
    const mergeConfig = [];

    const propsInfo = {
        dataHead: dataHead,
        dataColumn: dataColumn,
        apiCall: apiCall,
        apiCntCall: apiCntCall,
        excelFileName: excelFileName,
        excelHead: excelHead
    }

    const [state, setState] = useState({
        dataList: [],
        isSearched: false,
        isLoading: false
    })

    const [pageInfo, setPageInfo] = useState({
        paginationTF: false,
        currentPage: 1,
        itemsPerPage: 50, // 한 페이지당 보여줄 데이터 수
        totalItems: 0 // 전체 데이터 수
    });

    return (
        <Main>
            <div className='com-search'>
                <table>
                    <colgroup>
                        <col width="25%" />
                        <col width="25%" />
                        <col width="25%" />
                        <col width="25%" />
                    </colgroup>
                    <tbody>
                        <tr>
                            <NewCommonSelect
                                hospitalTF={false}
                                searchParams={searchParams}
                                handleInputChange={handleInputChange}
                            />
                        </tr>
                        <tr>
                            <th>내원시간</th>
                            <td colSpan={3}>
                                <input
                                    type="date"
                                    name="searchFromdate"
                                    value={searchParams.searchFromdate}
                                    onChange={handleInputChange}
                                />
                                ~
                                <input
                                    type="date"
                                    name="searchTodate"
                                    value={searchParams.searchTodate}
                                    onChange={handleInputChange}
                                    min={searchParams.searchFromdate}
                                />
                            </td>
                        </tr>
                        <tr>
                            <td colSpan="4">
                                <div>
                                    <span>
                                        <input type="checkbox" id="searchCheck1" name="searchCheck1" checked={searchParams.searchCheck1 === '1'} onChange={handleInputChange} />
                                        <label htmlFor="searchCheck1">진료외 방문 (챠트복사, 경유를 위한 접수) 제외</label>
                                    </span>
                                    <span>
                                        <input type="checkbox" id="searchCheck2" name="searchCheck2" checked={searchParams.searchCheck2 === '1'} onChange={handleInputChange} />
                                        <label htmlFor="searchCheck2">실시간 데이터 기준</label>
                                    </span>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <SearchBtn
                propsInfo={propsInfo}
                state={state}
                setState={setState}
                searchParams={searchParams}
                searchParamsAdditional={searchParamsAdditional}
                pageInfo={pageInfo}
                setPageInfo={setPageInfo}
                mergeConfig={mergeConfig}
            />
            <NewDataGrid
                propsInfo={propsInfo}
                state={state}
                pageInfo={pageInfo}
                setPageInfo={setPageInfo}
                mergeConfig={mergeConfig}
            />
        </Main>
    )
}

export default BdTongeMstay;